import { Expose, Type } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnUser } from '../user';
import { FsNotifyChannel } from './notify';
import { OrganizationNotifyType } from './organization-notify-type';

export class FsNotifyMessage extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  @Type(() => FsNotifyChannel)
  public channel: FsNotifyChannel;

  @Expose()
  @Type(() => Date)
  public createdTimestamp: Date;

  @Expose()
  @Type(() => Date)
  public updatedTimestamp: Date;

  @Expose()
  public subscribers: number;

  @Expose()
  @Type(() => SnUser)
  public user: SnUser;

  @Expose()
  public message: string;

  @ExposeRawData()
  public zipCodes: string;

  @Expose()
  @Type(() => OrganizationNotifyType)
  public organization: OrganizationNotifyType;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
